/**
 * Translations for Cookie Consent and Parent Registration Consent
 * Supports: English, Hindi, Punjabi, Tamil, Marathi, Telugu, Kannada, Odia, Bengali, Malayalam, Gujarati
 */

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা' },
  { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം' },
  { code: 'mr', name: 'Marathi', nativeName: 'मराठी' },
  { code: 'or', name: 'Odia', nativeName: 'ଓଡ଼ିଆ' },
  { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
];

export const translations = {
  // ========== ENGLISH ==========
  en: {
    common: {
      chooseLanguage: "Choose your language",
    },
    cookie: {
      title: "We value your privacy",
      description: "We use cookies to enhance your learning experience, analyze site usage, and assist in our marketing efforts. By clicking \"Accept All\", you consent to our use of cookies.",
      readPrivacyPolicy: "Read our Privacy Policy for more information.",
      acceptAll: "Accept All",
      necessaryOnly: "Necessary Only",
      managePreferences: "Manage Preferences",
      preferencesTitle: "Cookie Preferences",
      necessaryCookies: "Necessary Cookies",
      necessaryDescription: "Essential for the website to function. Cannot be disabled.",
      analyticsCookies: "Analytics Cookies",
      analyticsDescription: "Help us understand how visitors interact with our website.",
      marketingCookies: "Marketing Cookies",
      marketingDescription: "Used to deliver relevant advertisements and track campaign effectiveness.",
      savePreferences: "Save Preferences",
    },
    consent: {
      title: "Parental Consent (DPDP Act Compliance)",
      intro: "As the parent/legal guardian of the child named above, I hereby provide my explicit consent to Eduzy (Contentium Technologies) to:",
      points: [
        "Collect and process my child's personal data for educational purposes",
        "Use AI-powered adaptive learning to personalize their experience",
        "Store learning progress and assessment data securely",
        "Send educational notifications via WhatsApp and email"
      ],
      withdrawNote: "I understand I can withdraw this consent anytime from the Parent Dashboard settings.",
      checkboxLabel: "I agree to the above terms and provide my parental consent",
    }
  },

  // ========== HINDI ==========
  hi: {
    common: {
      chooseLanguage: "अपनी भाषा चुनें",
    },
    cookie: {
      title: "हम आपकी गोपनीयता का सम्मान करते हैं",
      description: "हम आपके सीखने के अनुभव को बेहतर बनाने, साइट के उपयोग का विश्लेषण करने और हमारे मार्केटिंग प्रयासों में सहायता करने के लिए कुकीज़ का उपयोग करते हैं। \"सभी स्वीकार करें\" पर क्लिक करके, आप हमारे कुकीज़ के उपयोग के लिए सहमति देते हैं।",
      readPrivacyPolicy: "अधिक जानकारी के लिए हमारी गोपनीयता नीति पढ़ें।",
      acceptAll: "सभी स्वीकार करें",
      necessaryOnly: "केवल आवश्यक",
      managePreferences: "प्राथमिकताएं प्रबंधित करें",
      preferencesTitle: "कुकी प्राथमिकताएं",
      necessaryCookies: "आवश्यक कुकीज़",
      necessaryDescription: "वेबसाइट के काम करने के लिए आवश्यक। अक्षम नहीं किया जा सकता।",
      analyticsCookies: "विश्लेषण कुकीज़",
      analyticsDescription: "हमें यह समझने में मदद करें कि विज़िटर हमारी वेबसाइट के साथ कैसे इंटरैक्ट करते हैं।",
      marketingCookies: "मार्केटिंग कुकीज़",
      marketingDescription: "प्रासंगिक विज्ञापन देने और अभियान की प्रभावशीलता को ट्रैक करने के लिए उपयोग किया जाता है।",
      savePreferences: "प्राथमिकताएं सहेजें",
    },
    consent: {
      title: "अभिभावकीय सहमति (DPDP अधिनियम अनुपालन)",
      intro: "ऊपर नामित बच्चे के माता-पिता/कानूनी अभिभावक के रूप में, मैं एतद्द्वारा Eduzy (Contentium Technologies) को अपनी स्पष्ट सहमति प्रदान करता/करती हूं:",
      points: [
        "शैक्षिक उद्देश्यों के लिए मेरे बच्चे के व्यक्तिगत डेटा को एकत्र और संसाधित करना",
        "उनके अनुभव को व्यक्तिगत बनाने के लिए AI-संचालित अनुकूली शिक्षण का उपयोग करना",
        "सीखने की प्रगति और मूल्यांकन डेटा को सुरक्षित रूप से संग्रहीत करना",
        "WhatsApp और ईमेल के माध्यम से शैक्षिक सूचनाएं भेजना"
      ],
      withdrawNote: "मैं समझता/समझती हूं कि मैं Parent Dashboard सेटिंग्स से कभी भी यह सहमति वापस ले सकता/सकती हूं।",
      checkboxLabel: "मैं उपरोक्त शर्तों से सहमत हूं और अपनी अभिभावकीय सहमति प्रदान करता/करती हूं",
    }
  },

  // ========== PUNJABI ==========
  pa: {
    common: {
      chooseLanguage: "ਆਪਣੀ ਭਾਸ਼ਾ ਚੁਣੋ",
    },
    cookie: {
      title: "ਅਸੀਂ ਤੁਹਾਡੀ ਗੋਪਨੀਯਤਾ ਦੀ ਕਦਰ ਕਰਦੇ ਹਾਂ",
      description: "ਅਸੀਂ ਤੁਹਾਡੇ ਸਿੱਖਣ ਦੇ ਤਜ਼ਰਬੇ ਨੂੰ ਬਿਹਤਰ ਬਣਾਉਣ, ਸਾਈਟ ਦੀ ਵਰਤੋਂ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਕਰਨ ਅਤੇ ਸਾਡੇ ਮਾਰਕੀਟਿੰਗ ਯਤਨਾਂ ਵਿੱਚ ਸਹਾਇਤਾ ਕਰਨ ਲਈ ਕੂਕੀਜ਼ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਹਾਂ। \"ਸਭ ਸਵੀਕਾਰ ਕਰੋ\" 'ਤੇ ਕਲਿੱਕ ਕਰਕੇ, ਤੁਸੀਂ ਸਾਡੀ ਕੂਕੀਜ਼ ਦੀ ਵਰਤੋਂ ਲਈ ਸਹਿਮਤੀ ਦਿੰਦੇ ਹੋ।",
      readPrivacyPolicy: "ਹੋਰ ਜਾਣਕਾਰੀ ਲਈ ਸਾਡੀ ਗੋਪਨੀਯਤਾ ਨੀਤੀ ਪੜ੍ਹੋ।",
      acceptAll: "ਸਭ ਸਵੀਕਾਰ ਕਰੋ",
      necessaryOnly: "ਸਿਰਫ਼ ਜ਼ਰੂਰੀ",
      managePreferences: "ਤਰਜੀਹਾਂ ਪ੍ਰਬੰਧਿਤ ਕਰੋ",
      preferencesTitle: "ਕੂਕੀ ਤਰਜੀਹਾਂ",
      necessaryCookies: "ਜ਼ਰੂਰੀ ਕੂਕੀਜ਼",
      necessaryDescription: "ਵੈੱਬਸਾਈਟ ਦੇ ਕੰਮ ਕਰਨ ਲਈ ਜ਼ਰੂਰੀ। ਅਯੋਗ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਦਾ।",
      analyticsCookies: "ਵਿਸ਼ਲੇਸ਼ਣ ਕੂਕੀਜ਼",
      analyticsDescription: "ਸਾਨੂੰ ਇਹ ਸਮਝਣ ਵਿੱਚ ਮਦਦ ਕਰੋ ਕਿ ਵਿਜ਼ਿਟਰ ਸਾਡੀ ਵੈੱਬਸਾਈਟ ਨਾਲ ਕਿਵੇਂ ਇੰਟਰੈਕਟ ਕਰਦੇ ਹਨ।",
      marketingCookies: "ਮਾਰਕੀਟਿੰਗ ਕੂਕੀਜ਼",
      marketingDescription: "ਸੰਬੰਧਿਤ ਇਸ਼ਤਿਹਾਰ ਦੇਣ ਅਤੇ ਮੁਹਿੰਮ ਦੀ ਪ੍ਰਭਾਵਸ਼ੀਲਤਾ ਨੂੰ ਟ੍ਰੈਕ ਕਰਨ ਲਈ ਵਰਤਿਆ ਜਾਂਦਾ ਹੈ।",
      savePreferences: "ਤਰਜੀਹਾਂ ਸੁਰੱਖਿਅਤ ਕਰੋ",
    },
    consent: {
      title: "ਮਾਪਿਆਂ ਦੀ ਸਹਿਮਤੀ (DPDP ਐਕਟ ਅਨੁਪਾਲਨ)",
      intro: "ਉੱਪਰ ਨਾਮਿਤ ਬੱਚੇ ਦੇ ਮਾਤਾ-ਪਿਤਾ/ਕਾਨੂੰਨੀ ਸਰਪ੍ਰਸਤ ਵਜੋਂ, ਮੈਂ ਇਸ ਦੁਆਰਾ Eduzy (Contentium Technologies) ਨੂੰ ਆਪਣੀ ਸਪੱਸ਼ਟ ਸਹਿਮਤੀ ਪ੍ਰਦਾਨ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ:",
      points: [
        "ਵਿਦਿਅਕ ਉਦੇਸ਼ਾਂ ਲਈ ਮੇਰੇ ਬੱਚੇ ਦੇ ਨਿੱਜੀ ਡੇਟਾ ਨੂੰ ਇਕੱਠਾ ਅਤੇ ਪ੍ਰੋਸੈਸ ਕਰਨਾ",
        "ਉਹਨਾਂ ਦੇ ਤਜ਼ਰਬੇ ਨੂੰ ਵਿਅਕਤੀਗਤ ਬਣਾਉਣ ਲਈ AI-ਸੰਚਾਲਿਤ ਅਨੁਕੂਲ ਸਿਖਲਾਈ ਦੀ ਵਰਤੋਂ ਕਰਨਾ",
        "ਸਿੱਖਣ ਦੀ ਤਰੱਕੀ ਅਤੇ ਮੁਲਾਂਕਣ ਡੇਟਾ ਨੂੰ ਸੁਰੱਖਿਅਤ ਢੰਗ ਨਾਲ ਸਟੋਰ ਕਰਨਾ",
        "WhatsApp ਅਤੇ ਈਮੇਲ ਰਾਹੀਂ ਵਿਦਿਅਕ ਸੂਚਨਾਵਾਂ ਭੇਜਣਾ"
      ],
      withdrawNote: "ਮੈਂ ਸਮਝਦਾ/ਸਮਝਦੀ ਹਾਂ ਕਿ ਮੈਂ Parent Dashboard ਸੈਟਿੰਗਾਂ ਤੋਂ ਕਿਸੇ ਵੀ ਸਮੇਂ ਇਹ ਸਹਿਮਤੀ ਵਾਪਸ ਲੈ ਸਕਦਾ/ਸਕਦੀ ਹਾਂ।",
      checkboxLabel: "ਮੈਂ ਉਪਰੋਕਤ ਸ਼ਰਤਾਂ ਨਾਲ ਸਹਿਮਤ ਹਾਂ ਅਤੇ ਆਪਣੀ ਮਾਪਿਆਂ ਦੀ ਸਹਿਮਤੀ ਪ੍ਰਦਾਨ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ",
    }
  },

  // ========== TAMIL ==========
  ta: {
    common: {
      chooseLanguage: "உங்கள் மொழியைத் தேர்ந்தெடுக்கவும்",
    },
    cookie: {
      title: "உங்கள் தனியுரிமையை நாங்கள் மதிக்கிறோம்",
      description: "உங்கள் கற்றல் அனுபவத்தை மேம்படுத்தவும், தள பயன்பாட்டை பகுப்பாய்வு செய்யவும், எங்கள் சந்தைப்படுத்தல் முயற்சிகளுக்கு உதவவும் குக்கீகளைப் பயன்படுத்துகிறோம். \"அனைத்தையும் ஏற்கவும்\" என்பதைக் கிளிக் செய்வதன் மூலம், எங்கள் குக்கீகளின் பயன்பாட்டிற்கு நீங்கள் சம்மதிக்கிறீர்கள்.",
      readPrivacyPolicy: "மேலும் தகவலுக்கு எங்கள் தனியுரிமைக் கொள்கையைப் படிக்கவும்.",
      acceptAll: "அனைத்தையும் ஏற்கவும்",
      necessaryOnly: "அவசியமானவை மட்டும்",
      managePreferences: "விருப்பங்களை நிர்வகி",
      preferencesTitle: "குக்கீ விருப்பங்கள்",
      necessaryCookies: "அவசியமான குக்கீகள்",
      necessaryDescription: "வலைத்தளம் செயல்பட அவசியம். முடக்க முடியாது.",
      analyticsCookies: "பகுப்பாய்வு குக்கீகள்",
      analyticsDescription: "பார்வையாளர்கள் எங்கள் வலைத்தளத்துடன் எவ்வாறு தொடர்புகொள்கிறார்கள் என்பதைப் புரிந்துகொள்ள எங்களுக்கு உதவுங்கள்.",
      marketingCookies: "சந்தைப்படுத்தல் குக்கீகள்",
      marketingDescription: "தொடர்புடைய விளம்பரங்களை வழங்கவும், பிரச்சார செயல்திறனைக் கண்காணிக்கவும் பயன்படுத்தப்படுகிறது.",
      savePreferences: "விருப்பங்களைச் சேமி",
    },
    consent: {
      title: "பெற்றோர் ஒப்புதல் (DPDP சட்ட இணக்கம்)",
      intro: "மேலே குறிப்பிட்ட குழந்தையின் பெற்றோர்/சட்டப்பூர்வ பாதுகாவலராக, Eduzy (Contentium Technologies) நிறுவனத்திற்கு எனது வெளிப்படையான ஒப்புதலை இதன்மூலம் வழங்குகிறேன்:",
      points: [
        "கல்வி நோக்கங்களுக்காக எனது குழந்தையின் தனிப்பட்ட தரவைச் சேகரித்து செயலாக்குதல்",
        "அவர்களின் அனுபவத்தைத் தனிப்பயனாக்க AI-இயக்கப்படும் தகவமைப்புக் கற்றலைப் பயன்படுத்துதல்",
        "கற்றல் முன்னேற்றம் மற்றும் மதிப்பீட்டுத் தரவைப் பாதுகாப்பாகச் சேமித்தல்",
        "WhatsApp மற்றும் மின்னஞ்சல் வழியாக கல்வி அறிவிப்புகளை அனுப்புதல்"
      ],
      withdrawNote: "Parent Dashboard அமைப்புகளிலிருந்து எந்த நேரத்திலும் இந்த ஒப்புதலை நான் திரும்பப் பெறலாம் என்பதை புரிந்துகொள்கிறேன்.",
      checkboxLabel: "மேற்கூறிய விதிமுறைகளை ஏற்றுக்கொண்டு எனது பெற்றோர் ஒப்புதலை வழங்குகிறேன்",
    }
  },

  // ========== MARATHI ==========
  mr: {
    common: {
      chooseLanguage: "आपली भाषा निवडा",
    },
    cookie: {
      title: "आम्ही तुमच्या गोपनीयतेचा आदर करतो",
      description: "तुमचा शिकण्याचा अनुभव वाढवण्यासाठी, साइट वापराचे विश्लेषण करण्यासाठी आणि आमच्या मार्केटिंग प्रयत्नांना मदत करण्यासाठी आम्ही कुकीज वापरतो. \"सर्व स्वीकारा\" वर क्लिक करून, तुम्ही आमच्या कुकीज वापरास संमती देता.",
      readPrivacyPolicy: "अधिक माहितीसाठी आमचे गोपनीयता धोरण वाचा.",
      acceptAll: "सर्व स्वीकारा",
      necessaryOnly: "फक्त आवश्यक",
      managePreferences: "प्राधान्ये व्यवस्थापित करा",
      preferencesTitle: "कुकी प्राधान्ये",
      necessaryCookies: "आवश्यक कुकीज",
      necessaryDescription: "वेबसाइट कार्य करण्यासाठी आवश्यक. अक्षम करता येत नाही.",
      analyticsCookies: "विश्लेषण कुकीज",
      analyticsDescription: "अभ्यागत आमच्या वेबसाइटशी कसे संवाद साधतात हे समजून घेण्यात आम्हाला मदत करा.",
      marketingCookies: "मार्केटिंग कुकीज",
      marketingDescription: "संबंधित जाहिराती देण्यासाठी आणि मोहिमेची प्रभावीता ट्रॅक करण्यासाठी वापरले जाते.",
      savePreferences: "प्राधान्ये जतन करा",
    },
    consent: {
      title: "पालकांची संमती (DPDP कायदा अनुपालन)",
      intro: "वर नमूद केलेल्या मुलाचे पालक/कायदेशीर पालक म्हणून, मी याद्वारे Eduzy (Contentium Technologies) ला माझी स्पष्ट संमती देतो/देते:",
      points: [
        "शैक्षणिक हेतूंसाठी माझ्या मुलाचा वैयक्तिक डेटा गोळा करणे आणि प्रक्रिया करणे",
        "त्यांचा अनुभव वैयक्तिकृत करण्यासाठी AI-चालित अनुकूली शिक्षण वापरणे",
        "शिकण्याची प्रगती आणि मूल्यांकन डेटा सुरक्षितपणे संग्रहित करणे",
        "WhatsApp आणि ईमेलद्वारे शैक्षणिक सूचना पाठवणे"
      ],
      withdrawNote: "मला समजते की मी Parent Dashboard सेटिंग्जमधून कधीही ही संमती मागे घेऊ शकतो/शकते.",
      checkboxLabel: "मी वरील अटींशी सहमत आहे आणि माझी पालकांची संमती देतो/देते",
    }
  },

  // ========== TELUGU ==========
  te: {
    common: {
      chooseLanguage: "మీ భాషను ఎంచుకోండి",
    },
    cookie: {
      title: "మేము మీ గోప్యతను గౌరవిస్తాము",
      description: "మీ అభ్యాస అనుభవాన్ని మెరుగుపరచడానికి, సైట్ వినియోగాన్ని విశ్లేషించడానికి మరియు మా మార్కెటింగ్ ప్రయత్నాలకు సహాయం చేయడానికి మేము కుక్కీలను ఉపయోగిస్తాము. \"అన్నీ అంగీకరించు\" క్లిక్ చేయడం ద్వారా, మీరు మా కుక్కీల వినియోగానికి సమ్మతిస్తారు.",
      readPrivacyPolicy: "మరింత సమాచారం కోసం మా గోప్యతా విధానాన్ని చదవండి.",
      acceptAll: "అన్నీ అంగీకరించు",
      necessaryOnly: "అవసరమైనవి మాత్రమే",
      managePreferences: "ప్రాధాన్యతలను నిర్వహించు",
      preferencesTitle: "కుక్కీ ప్రాధాన్యతలు",
      necessaryCookies: "అవసరమైన కుక్కీలు",
      necessaryDescription: "వెబ్‌సైట్ పని చేయడానికి అవసరం. నిలిపివేయడం సాధ్యం కాదు.",
      analyticsCookies: "విశ్లేషణ కుక్కీలు",
      analyticsDescription: "సందర్శకులు మా వెబ్‌సైట్‌తో ఎలా సంభాషిస్తారో అర్థం చేసుకోవడంలో మాకు సహాయపడండి.",
      marketingCookies: "మార్కెటింగ్ కుక్కీలు",
      marketingDescription: "సంబంధిత ప్రకటనలను అందించడానికి మరియు ప్రచార ప్రభావాన్ని ట్రాక్ చేయడానికి ఉపయోగించబడుతుంది.",
      savePreferences: "ప్రాధాన్యతలను సేవ్ చేయి",
    },
    consent: {
      title: "తల్లిదండ్రుల సమ్మతి (DPDP చట్టం అనుసరణ)",
      intro: "పైన పేర్కొన్న బిడ్డ యొక్క తల్లిదండ్రులు/చట్టపరమైన సంరక్షకునిగా, నేను ఇందుమూలంగా Eduzy (Contentium Technologies)కు నా స్పష్టమైన సమ్మతిని అందిస్తున్నాను:",
      points: [
        "విద్యా ప్రయోజనాల కోసం నా బిడ్డ యొక్క వ్యక్తిగత డేటాను సేకరించడం మరియు ప్రాసెస్ చేయడం",
        "వారి అనుభవాన్ని వ్యక్తిగతీకరించడానికి AI-ఆధారిత అనుకూల అభ్యాసాన్ని ఉపయోగించడం",
        "అభ్యాస పురోగతి మరియు అంచనా డేటాను సురక్షితంగా నిల్వ చేయడం",
        "WhatsApp మరియు ఇమెయిల్ ద్వారా విద్యా నోటిఫికేషన్లు పంపడం"
      ],
      withdrawNote: "Parent Dashboard సెట్టింగ్‌ల నుండి ఎప్పుడైనా ఈ సమ్మతిని నేను ఉపసంహరించుకోగలనని నాకు తెలుసు.",
      checkboxLabel: "పై నిబంధనలకు నేను అంగీకరిస్తున్నాను మరియు నా తల్లిదండ్రుల సమ్మతిని అందిస్తున్నాను",
    }
  },

  // ========== KANNADA ==========
  kn: {
    common: {
      chooseLanguage: "ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    },
    cookie: {
      title: "ನಾವು ನಿಮ್ಮ ಗೌಪ್ಯತೆಯನ್ನು ಗೌರವಿಸುತ್ತೇವೆ",
      description: "ನಿಮ್ಮ ಕಲಿಕೆಯ ಅನುಭವವನ್ನು ಹೆಚ್ಚಿಸಲು, ಸೈಟ್ ಬಳಕೆಯನ್ನು ವಿಶ್ಲೇಷಿಸಲು ಮತ್ತು ನಮ್ಮ ಮಾರ್ಕೆಟಿಂಗ್ ಪ್ರಯತ್ನಗಳಿಗೆ ಸಹಾಯ ಮಾಡಲು ನಾವು ಕುಕೀಗಳನ್ನು ಬಳಸುತ್ತೇವೆ. \"ಎಲ್ಲವನ್ನೂ ಸ್ವೀಕರಿಸಿ\" ಕ್ಲಿಕ್ ಮಾಡುವ ಮೂಲಕ, ನೀವು ನಮ್ಮ ಕುಕೀಗಳ ಬಳಕೆಗೆ ಒಪ್ಪಿಗೆ ನೀಡುತ್ತೀರಿ.",
      readPrivacyPolicy: "ಹೆಚ್ಚಿನ ಮಾಹಿತಿಗಾಗಿ ನಮ್ಮ ಗೌಪ್ಯತಾ ನೀತಿಯನ್ನು ಓದಿ.",
      acceptAll: "ಎಲ್ಲವನ್ನೂ ಸ್ವೀಕರಿಸಿ",
      necessaryOnly: "ಅಗತ್ಯವಾದವು ಮಾತ್ರ",
      managePreferences: "ಆದ್ಯತೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
      preferencesTitle: "ಕುಕೀ ಆದ್ಯತೆಗಳು",
      necessaryCookies: "ಅಗತ್ಯ ಕುಕೀಗಳು",
      necessaryDescription: "ವೆಬ್‌ಸೈಟ್ ಕಾರ್ಯನಿರ್ವಹಿಸಲು ಅಗತ್ಯ. ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ.",
      analyticsCookies: "ವಿಶ್ಲೇಷಣೆ ಕುಕೀಗಳು",
      analyticsDescription: "ಸಂದರ್ಶಕರು ನಮ್ಮ ವೆಬ್‌ಸೈಟ್‌ನೊಂದಿಗೆ ಹೇಗೆ ಸಂವಹನ ನಡೆಸುತ್ತಾರೆ ಎಂಬುದನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ನಮಗೆ ಸಹಾಯ ಮಾಡಿ.",
      marketingCookies: "ಮಾರ್ಕೆಟಿಂಗ್ ಕುಕೀಗಳು",
      marketingDescription: "ಸಂಬಂಧಿತ ಜಾಹೀರಾತುಗಳನ್ನು ತಲುಪಿಸಲು ಮತ್ತು ಪ್ರಚಾರದ ಪರಿಣಾಮಕಾರಿತ್ವವನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಲು ಬಳಸಲಾಗುತ್ತದೆ.",
      savePreferences: "ಆದ್ಯತೆಗಳನ್ನು ಉಳಿಸಿ",
    },
    consent: {
      title: "ಪೋಷಕರ ಒಪ್ಪಿಗೆ (DPDP ಕಾಯಿದೆ ಅನುಸರಣೆ)",
      intro: "ಮೇಲೆ ಹೆಸರಿಸಿದ ಮಗುವಿನ ಪೋಷಕ/ಕಾನೂನು ರಕ್ಷಕನಾಗಿ, ನಾನು ಇದರ ಮೂಲಕ Eduzy (Contentium Technologies) ಗೆ ನನ್ನ ಸ್ಪಷ್ಟ ಒಪ್ಪಿಗೆಯನ್ನು ನೀಡುತ್ತೇನೆ:",
      points: [
        "ಶೈಕ್ಷಣಿಕ ಉದ್ದೇಶಗಳಿಗಾಗಿ ನನ್ನ ಮಗುವಿನ ವೈಯಕ್ತಿಕ ಡೇಟಾವನ್ನು ಸಂಗ್ರಹಿಸಲು ಮತ್ತು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲು",
        "ಅವರ ಅನುಭವವನ್ನು ವೈಯಕ್ತೀಕರಿಸಲು AI-ಚಾಲಿತ ಹೊಂದಾಣಿಕೆ ಕಲಿಕೆಯನ್ನು ಬಳಸಲು",
        "ಕಲಿಕೆಯ ಪ್ರಗತಿ ಮತ್ತು ಮೌಲ್ಯಮಾಪನ ಡೇಟಾವನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಸಂಗ್ರಹಿಸಲು",
        "WhatsApp ಮತ್ತು ಇಮೇಲ್ ಮೂಲಕ ಶೈಕ್ಷಣಿಕ ಅಧಿಸೂಚನೆಗಳನ್ನು ಕಳುಹಿಸಲು"
      ],
      withdrawNote: "Parent Dashboard ಸೆಟ್ಟಿಂಗ್‌ಗಳಿಂದ ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಈ ಒಪ್ಪಿಗೆಯನ್ನು ನಾನು ಹಿಂಪಡೆಯಬಹುದು ಎಂದು ನನಗೆ ತಿಳಿದಿದೆ.",
      checkboxLabel: "ನಾನು ಮೇಲಿನ ನಿಯಮಗಳನ್ನು ಒಪ್ಪುತ್ತೇನೆ ಮತ್ತು ನನ್ನ ಪೋಷಕರ ಒಪ್ಪಿಗೆಯನ್ನು ನೀಡುತ್ತೇನೆ",
    }
  },

  // ========== BENGALI ==========
  bn: {
    common: {
      chooseLanguage: "আপনার ভাষা নির্বাচন করুন",
    },
    cookie: {
      title: "আমরা আপনার গোপনীয়তাকে মূল্য দিই",
      description: "আপনার শেখার অভিজ্ঞতা উন্নত করতে, সাইটের ব্যবহার বিশ্লেষণ করতে এবং আমাদের মার্কেটিং প্রচেষ্টায় সহায়তা করতে আমরা কুকিজ ব্যবহার করি। \"সব গ্রহণ করুন\" ক্লিক করে, আপনি আমাদের কুকিজ ব্যবহারে সম্মতি দেন।",
      readPrivacyPolicy: "আরও তথ্যের জন্য আমাদের গোপনীয়তা নীতি পড়ুন।",
      acceptAll: "সব গ্রহণ করুন",
      necessaryOnly: "শুধুমাত্র প্রয়োজনীয়",
      managePreferences: "পছন্দ পরিচালনা করুন",
      preferencesTitle: "কুকি পছন্দসমূহ",
      necessaryCookies: "প্রয়োজনীয় কুকিজ",
      necessaryDescription: "ওয়েবসাইট কাজ করার জন্য অপরিহার্য। নিষ্ক্রিয় করা যাবে না।",
      analyticsCookies: "বিশ্লেষণ কুকিজ",
      analyticsDescription: "দর্শকরা কীভাবে আমাদের ওয়েবসাইটের সাথে ইন্টারঅ্যাক্ট করে তা বুঝতে আমাদের সাহায্য করুন।",
      marketingCookies: "মার্কেটিং কুকিজ",
      marketingDescription: "প্রাসঙ্গিক বিজ্ঞাপন সরবরাহ করতে এবং প্রচারাভিযানের কার্যকারিতা ট্র্যাক করতে ব্যবহৃত হয়।",
      savePreferences: "পছন্দ সংরক্ষণ করুন",
    },
    consent: {
      title: "অভিভাবকের সম্মতি (DPDP আইন মেনে চলা)",
      intro: "উপরে নামকৃত শিশুর অভিভাবক/আইনি অভিভাবক হিসাবে, আমি এতদ্বারা Eduzy (Contentium Technologies)-কে আমার স্পষ্ট সম্মতি প্রদান করছি:",
      points: [
        "শিক্ষামূলক উদ্দেশ্যে আমার সন্তানের ব্যক্তিগত তথ্য সংগ্রহ ও প্রক্রিয়াকরণ করা",
        "তাদের অভিজ্ঞতা ব্যক্তিগতকৃত করতে AI-চালিত অভিযোজিত শিক্ষা ব্যবহার করা",
        "শেখার অগ্রগতি এবং মূল্যায়ন ডেটা নিরাপদে সংরক্ষণ করা",
        "WhatsApp এবং ইমেলের মাধ্যমে শিক্ষামূলক বিজ্ঞপ্তি পাঠানো"
      ],
      withdrawNote: "আমি বুঝি যে আমি Parent Dashboard সেটিংস থেকে যেকোনো সময় এই সম্মতি প্রত্যাহার করতে পারি।",
      checkboxLabel: "আমি উপরের শর্তাবলীতে সম্মত এবং আমার অভিভাবকের সম্মতি প্রদান করছি",
    }
  },

  // ========== GUJARATI ==========
  gu: {
    common: {
      chooseLanguage: "તમારી ભાષા પસંદ કરો",
    },
    cookie: {
      title: "અમે તમારી ગોપનીયતાને મહત્વ આપીએ છીએ",
      description: "તમારા શીખવાના અનુભવને વધારવા, સાઇટના ઉપયોગનું વિશ્લેષણ કરવા અને અમારા માર્કેટિંગ પ્રયાસોમાં મદદ કરવા માટે અમે કૂકીઝનો ઉપયોગ કરીએ છીએ. \"બધું સ્વીકારો\" પર ક્લિક કરીને, તમે અમારી કૂકીઝના ઉપયોગ માટે સંમતિ આપો છો.",
      readPrivacyPolicy: "વધુ માહિતી માટે અમારી ગોપનીયતા નીતિ વાંચો.",
      acceptAll: "બધું સ્વીકારો",
      necessaryOnly: "માત્ર જરૂરી",
      managePreferences: "પસંદગીઓ મેનેજ કરો",
      preferencesTitle: "કૂકી પસંદગીઓ",
      necessaryCookies: "જરૂરી કૂકીઝ",
      necessaryDescription: "વેબસાઇટ કાર્ય કરવા માટે આવશ્યક. અક્ષમ કરી શકાતી નથી.",
      analyticsCookies: "વિશ્લેષણ કૂકીઝ",
      analyticsDescription: "મુલાકાતીઓ અમારી વેબસાઇટ સાથે કેવી રીતે ક્રિયાપ્રતિક્રિયા કરે છે તે સમજવામાં અમને મદદ કરો.",
      marketingCookies: "માર્કેટિંગ કૂકીઝ",
      marketingDescription: "સંબંધિત જાહેરાતો પહોંચાડવા અને અભિયાનની અસરકારકતાને ટ્રેક કરવા માટે વપરાય છે.",
      savePreferences: "પસંદગીઓ સાચવો",
    },
    consent: {
      title: "માતાપિતાની સંમતિ (DPDP અધિનિયમ પાલન)",
      intro: "ઉપર નામ આપેલા બાળકના માતાપિતા/કાનૂની વાલી તરીકે, હું આથી Eduzy (Contentium Technologies)ને મારી સ્પષ્ટ સંમતિ આપું છું:",
      points: [
        "શૈક્ષણિક હેતુઓ માટે મારા બાળકની અંગત માહિતી એકત્રિત અને પ્રોસેસ કરવી",
        "તેમના અનુભવને વ્યક્તિગત બનાવવા માટે AI-સંચાલિત અનુકૂલનશીલ શિક્ષણનો ઉપયોગ કરવો",
        "શીખવાની પ્રગતિ અને મૂલ્યાંકન ડેટા સુરક્ષિત રીતે સંગ્રહિત કરવો",
        "WhatsApp અને ઇમેઇલ દ્વારા શૈક્ષણિક સૂચનાઓ મોકલવી"
      ],
      withdrawNote: "હું સમજું છું કે હું Parent Dashboard સેટિંગ્સમાંથી કોઈપણ સમયે આ સંમતિ પાછી ખેંચી શકું છું.",
      checkboxLabel: "હું ઉપરોક્ત શરતો સાથે સંમત છું અને મારી માતાપિતાની સંમતિ આપું છું",
    }
  },

  // ========== MALAYALAM ==========
  ml: {
    common: {
      chooseLanguage: "നിങ്ങളുടെ ഭാഷ തിരഞ്ഞെടുക്കുക",
    },
    cookie: {
      title: "നിങ്ങളുടെ സ്വകാര്യതയെ ഞങ്ങൾ വിലമതിക്കുന്നു",
      description: "നിങ്ങളുടെ പഠന അനുഭവം മെച്ചപ്പെടുത്താനും, സൈറ്റ് ഉപയോഗം വിശകലനം ചെയ്യാനും, ഞങ്ങളുടെ മാർക്കറ്റിംഗ് ശ്രമങ്ങളെ സഹായിക്കാനും ഞങ്ങൾ കുക്കികൾ ഉപയോഗിക്കുന്നു. \"എല്ലാം അംഗീകരിക്കുക\" ക്ലിക്ക് ചെയ്യുന്നതിലൂടെ, നിങ്ങൾ ഞങ്ങളുടെ കുക്കികളുടെ ഉപയോഗത്തിന് സമ്മതിക്കുന്നു.",
      readPrivacyPolicy: "കൂടുതൽ വിവരങ്ങൾക്ക് ഞങ്ങളുടെ സ്വകാര്യതാ നയം വായിക്കുക.",
      acceptAll: "എല്ലാം അംഗീകരിക്കുക",
      necessaryOnly: "ആവശ്യമുള്ളവ മാത്രം",
      managePreferences: "മുൻഗണനകൾ നിയന്ത്രിക്കുക",
      preferencesTitle: "കുക്കി മുൻഗണനകൾ",
      necessaryCookies: "ആവശ്യമായ കുക്കികൾ",
      necessaryDescription: "വെബ്സൈറ്റ് പ്രവർത്തിക്കാൻ അത്യാവശ്യമാണ്. പ്രവർത്തനരഹിതമാക്കാൻ കഴിയില്ല.",
      analyticsCookies: "വിശകലന കുക്കികൾ",
      analyticsDescription: "സന്ദർശകർ ഞങ്ങളുടെ വെബ്സൈറ്റുമായി എങ്ങനെ ഇടപെടുന്നുവെന്ന് മനസ്സിലാക്കാൻ ഞങ്ങളെ സഹായിക്കുക.",
      marketingCookies: "മാർക്കറ്റിംഗ് കുക്കികൾ",
      marketingDescription: "പ്രസക്തമായ പരസ്യങ്ങൾ നൽകാനും കാമ്പെയ്ൻ ഫലപ്രാപ്തി ട്രാക്ക് ചെയ്യാനും ഉപയോഗിക്കുന്നു.",
      savePreferences: "മുൻഗണനകൾ സേവ് ചെയ്യുക",
    },
    consent: {
      title: "രക്ഷാകർതൃ സമ്മതം (DPDP നിയമ പാലനം)",
      intro: "മുകളിൽ പേരുള്ള കുട്ടിയുടെ രക്ഷിതാവ്/നിയമപരമായ രക്ഷാകർത്താവ് എന്ന നിലയിൽ, ഞാൻ ഇതിനാൽ Eduzy (Contentium Technologies)-ന് എന്റെ വ്യക്തമായ സമ്മതം നൽകുന്നു:",
      points: [
        "വിദ്യാഭ്യാസ ആവശ്യങ്ങൾക്കായി എന്റെ കുട്ടിയുടെ വ്യക്തിഗത ഡാറ്റ ശേഖരിക്കാനും പ്രോസസ്സ് ചെയ്യാനും",
        "അവരുടെ അനുഭവം വ്യക്തിഗതമാക്കാൻ AI-പവർഡ് അഡാപ്റ്റീവ് ലേണിംഗ് ഉപയോഗിക്കാൻ",
        "പഠന പുരോഗതിയും വിലയിരുത്തൽ ഡാറ്റയും സുരക്ഷിതമായി സംഭരിക്കാൻ",
        "WhatsApp-ഉം ഇമെയിലും വഴി വിദ്യാഭ്യാസ അറിയിപ്പുകൾ അയയ്ക്കാൻ"
      ],
      withdrawNote: "Parent Dashboard ക്രമീകരണങ്ങളിൽ നിന്ന് എപ്പോൾ വേണമെങ്കിലും ഈ സമ്മതം പിൻവലിക്കാമെന്ന് എനിക്കറിയാം.",
      checkboxLabel: "മുകളിലുള്ള നിബന്ധനകളോട് ഞാൻ യോജിക്കുന്നു, എന്റെ രക്ഷാകർതൃ സമ്മതം നൽകുന്നു",
    }
  },

  // ========== ODIA ==========
  or: {
    common: {
      chooseLanguage: "ଆପଣଙ୍କ ଭାଷା ବାଛନ୍ତୁ",
    },
    cookie: {
      title: "ଆମେ ଆପଣଙ୍କ ଗୋପନୀୟତାକୁ ମୂଲ୍ୟ ଦେଉଁ",
      description: "ଆପଣଙ୍କ ଶିକ୍ଷଣ ଅନୁଭବକୁ ବୃଦ୍ଧି କରିବା, ସାଇଟ୍ ବ୍ୟବହାର ବିଶ୍ଳେଷଣ କରିବା ଏବଂ ଆମର ମାର୍କେଟିଂ ପ୍ରୟାସରେ ସହାୟତା କରିବା ପାଇଁ ଆମେ କୁକିଜ୍ ବ୍ୟବହାର କରୁ। \"ସମସ୍ତ ଗ୍ରହଣ କରନ୍ତୁ\" କ୍ଲିକ୍ କରି, ଆପଣ ଆମର କୁକିଜ୍ ବ୍ୟବହାର ପାଇଁ ସମ୍ମତି ଦିଅନ୍ତି।",
      readPrivacyPolicy: "ଅଧିକ ସୂଚନା ପାଇଁ ଆମର ଗୋପନୀୟତା ନୀତି ପଢ଼ନ୍ତୁ।",
      acceptAll: "ସମସ୍ତ ଗ୍ରହଣ କରନ୍ତୁ",
      necessaryOnly: "କେବଳ ଆବଶ୍ୟକ",
      managePreferences: "ପସନ୍ଦ ପରିଚାଳନା କରନ୍ତୁ",
      preferencesTitle: "କୁକି ପସନ୍ଦ",
      necessaryCookies: "ଆବଶ୍ୟକ କୁକିଜ୍",
      necessaryDescription: "ୱେବସାଇଟ୍ କାର୍ଯ୍ୟ କରିବା ପାଇଁ ଅପରିହାର୍ଯ୍ୟ। ନିଷ୍କ୍ରିୟ କରାଯାଇ ପାରିବ ନାହିଁ।",
      analyticsCookies: "ବିଶ୍ଳେଷଣ କୁକିଜ୍",
      analyticsDescription: "ପରିଦର୍ଶକମାନେ ଆମ ୱେବସାଇଟ୍ ସହିତ କିପରି ଯୋଗାଯୋଗ କରନ୍ତି ତାହା ବୁଝିବାରେ ଆମକୁ ସାହାଯ୍ୟ କରନ୍ତୁ।",
      marketingCookies: "ମାର୍କେଟିଂ କୁକିଜ୍",
      marketingDescription: "ପ୍ରାସଙ୍ଗିକ ବିଜ୍ଞାପନ ଦେବା ଏବଂ ଅଭିଯାନର ପ୍ରଭାବଶୀଳତା ଟ୍ରାକ୍ କରିବା ପାଇଁ ବ୍ୟବହୃତ।",
      savePreferences: "ପସନ୍ଦ ସଞ୍ଚୟ କରନ୍ତୁ",
    },
    consent: {
      title: "ଅଭିଭାବକଙ୍କ ସମ୍ମତି (DPDP ଆଇନ ଅନୁପାଳନ)",
      intro: "ଉପରେ ନାମିତ ଶିଶୁର ପିତାମାତା/ଆଇନଗତ ଅଭିଭାବକ ଭାବରେ, ମୁଁ ଏତଦ୍ୱାରା Eduzy (Contentium Technologies)କୁ ମୋର ସ୍ପଷ୍ଟ ସମ୍ମତି ପ୍ରଦାନ କରୁଛି:",
      points: [
        "ଶିକ୍ଷାମୂଳକ ଉଦ୍ଦେଶ୍ୟ ପାଇଁ ମୋ ପିଲାର ବ୍ୟକ୍ତିଗତ ତଥ୍ୟ ସଂଗ୍ରହ ଏବଂ ପ୍ରକ୍ରିୟାକରଣ କରିବା",
        "ସେମାନଙ୍କ ଅନୁଭବକୁ ବ୍ୟକ୍ତିଗତ କରିବା ପାଇଁ AI-ଚାଳିତ ଅନୁକୂଳ ଶିକ୍ଷଣ ବ୍ୟବହାର କରିବା",
        "ଶିକ୍ଷଣ ପ୍ରଗତି ଏବଂ ମୂଲ୍ୟାଙ୍କନ ତଥ୍ୟକୁ ନିରାପଦ ଭାବରେ ସଂରକ୍ଷଣ କରିବା",
        "WhatsApp ଏବଂ ଇମେଲ୍ ମାଧ୍ୟମରେ ଶିକ୍ଷାମୂଳକ ବିଜ୍ଞପ୍ତି ପଠାଇବା"
      ],
      withdrawNote: "ମୁଁ ବୁଝୁଛି ଯେ ମୁଁ Parent Dashboard ସେଟିଂସ୍ ରୁ ଯେକୌଣସି ସମୟରେ ଏହି ସମ୍ମତି ପ୍ରତ୍ୟାହାର କରିପାରିବି।",
      checkboxLabel: "ମୁଁ ଉପରୋକ୍ତ ସର୍ତ୍ତାବଳୀ ସହ ସହମତ ଏବଂ ମୋର ଅଭିଭାବକଙ୍କ ସମ୍ମତି ପ୍ରଦାନ କରୁଛି",
    }
  }
};
/**
 * Get translation for a specific key
 * @param {string} lang - Language code ('en', 'hi', 'bn', 'gu', 'kn', 'ml', 'mr', 'or', 'pa', 'ta', 'te')
 * @param {string} section - Section ('cookie' or 'consent')
 * @param {string} key - Translation key
 * @returns {string|array} - Translated text
 */
export function getTranslation(lang, section, key) {
  const langData = translations[lang] || translations.en;
  const sectionData = langData[section] || {};
  return sectionData[key] || translations.en[section]?.[key] || key;
}

/**
 * Get all translations for a section
 * @param {string} lang - Language code
 * @param {string} section - Section name
 * @returns {object} - All translations for the section
 */
export function getSectionTranslations(lang, section) {
  const langData = translations[lang] || translations.en;
  return langData[section] || translations.en[section] || {};
}

export default translations;
